import Vue from 'vue';
import { getTagCommander } from '@declaration/helpers/tagCommander';
const wrapper = getTagCommander();
wrapper === null || wrapper === void 0 ? void 0 : wrapper.setDebug(process.env.NODE_ENV !== 'production');
export default ({ app }) => {
    app.$tcWrapper = wrapper;
};
Vue.prototype.$tcWrapper = wrapper;
